<ng-container [formGroup]="formGroup">
  <span class="p-float-label">
    <p-autoComplete
      [inputId]="fieldName"
      [formControlName]="fieldName"
      [suggestions]="results"
      (completeMethod)="search($event)"
      [class]="validation()"
    ></p-autoComplete>
    <label [for]="fieldName">{{ formatFieldName(label) }}</label>
  </span>
  <app-error-message
    [control]="control"
    [field]="fieldName"
    [label]="label"
  ></app-error-message>
</ng-container>
